import { defineStore } from "pinia";
import {
  FetchState,
  NotificationPreferencesState,
    NotificationPreferencesGetResponse,
} from "@/shared/types";
import {
    getNotificationPreferences,
} from "@/shared/api/notificationPreferencesService";
import Vue from "vue";
import * as storeHelper from "@/shared/storeHelper";
import _ from "lodash";
import { useNotifierStore } from "./notifier";

export const initialState: NotificationPreferencesState = {
    notificationPreferencesFetchState: FetchState.Uninitialized,
    notificationPreferences: [],
};

export const useNotificationPreferencesStore = defineStore("notificationPreferences", {
    state: (): NotificationPreferencesState => (_.cloneDeep(initialState)),
    getters: {
        notificationPreferencesLoading: state => state.notificationPreferencesFetchState === FetchState.Loading,
        notificationPreferencesLoaded: state => state.notificationPreferencesFetchState === FetchState.Loaded,
        notificationPreferencesList: state => state.notificationPreferences,
    },
    actions: {

        setNotificationPreferences (response: NotificationPreferencesGetResponse) {
            this.notificationPreferences = response.notificationPreferences;
        },

        setNotificationPreferencesFetchState (fetchState: FetchState) {
            this.notificationPreferencesFetchState = fetchState;
        },

        async getNotificationPreferences () {
            if (this.notificationPreferencesFetchState !== FetchState.Uninitialized) {
                return Promise.resolve();
            }
            this.setNotificationPreferencesFetchState(FetchState.Loading);
            try {
                const response = await getNotificationPreferences();
                this.setNotificationPreferencesFetchState(FetchState.Loaded);
                this.setNotificationPreferences(response.data);
            } catch (err) {
                this.setNotificationPreferencesFetchState(FetchState.Failed);
                storeHelper.handleError({ error: err, rethrow: true, timeout: 5000 });
            }
        },
    }
});